import { makeVar, useReactiveVar } from '@apollo/client'
import dayjs from 'dayjs'

import { IS_SSR } from '@web/libs/utils'

import { isAfterHydrationVar } from './useGlobalAfterHydration'

export const SSRDateTimeVar = makeVar<string>(new Date().toISOString())

const useNow = () => {
  const isAfterHydration = useReactiveVar(isAfterHydrationVar)
  const SSRDateTime = useReactiveVar(SSRDateTimeVar)

  if (IS_SSR || !isAfterHydration) {
    return dayjs(SSRDateTime)
  }

  return dayjs()
}

export default useNow
